export const mixinPushErrorRoute = {
  methods: {
    routerPush(error) {
      this.$router.push({ name: 'Error', query: { error } });
    },
    pushErrorRoute(err) {
      const errorCode = err.response ? err.response.status : null;

      if (errorCode === 403) {
        const errorName = err.response && err.response.data === 'Chargeback' ? 'BLACKLISTED' : 'BLACKLIST';
        this.routerPush(errorName);
      }

      if (errorCode === 406) this.routerPush('NOT_CLARO_NUMBER');

      // No existe la ruta con nombre DeactivateWifi
      if (errorCode === 409) this.$router.push({ name: 'DeactivateWifi' });

      if (errorCode === 412) {
        if (err.response.data === 'IvrNumberHasARejectedCheckProblemException' && this.country.pais === this.GT) this.routerPush('REJECTED_CHECKS');
        this.routerPush('CORP_NUMBER');
      }

      this.isError = this.$t('error.CONNECTION');
    }
  }
};

export const mixinPushInvoicesErrorRoute = {
  methods: {
    routerPush(error) {
      this.$router.push({ name: 'Error', query: { error } });
    },
    pushInvoicesErrorRoute(err) {
      const errorCode = err.response ? err.response.status : null;
      // 401 error invalid token
      if (errorCode === 401) this.$router.push({ name: 'SetNumber' });

      if (errorCode === 403) this.routerPush('BLACKLIST');

      if (errorCode === 406) this.routerPush('INCONSISTENCY');

      if (errorCode === 409) {
        this.$router.push(
          {
            name: 'HasActiveRecurrence',
            query: { date: err.response.data }
          }
        );
      }

      if (errorCode === 500) this.routerPush('GENERIC_ERROR');

      this.isError = this.$t('error.INVOICE_ABORTED');
    }
  }
};
